import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'lg:bg-white-100 mt-14 md:mt-30 lg:mt-0',
    container:
      'lg:relative lg:mx-auto lg:min-h-[700px] lg:max-w-[1366px] lg:px-10 lg:pt-30 lg:pb-[45px]',
    imageWrapper: 'relative lg:w-[63%] lg:max-w-200',
    imageHeroBanner: 'w-full',
    info: 'lg:absolute lg:right-auto lg:bottom-11 lg:left-[calc(50%+265px)]',
    infoText:
      'lg:text-20 -mb-4 text-[20px] leading-[1.3] font-medium text-[#00C389] uppercase lg:-mb-[13px] lg:text-[32px]',
    infoDescription:
      'text-brand-bioderma text-[20px] leading-[1.2] font-medium uppercase lg:text-xl',
    infoSup: '-top-[1.2em] text-[10px] font-normal',
    infoTextNumber:
      'text-[56px] leading-[1.3] font-bold text-[#00C389] lg:text-[80px]',
    content: 'max-lg:[17px] bg-white-100 flex max-lg:pb-[52px]',
    contentText: 'z-1 pt-5 pl-4 md:pl-10 lg:max-w-[50%] lg:pl-0',
    image:
      'absolute top-22 right-3 z-3 max-w-[158px] max-lg:max-w-[102px] md:top-1/2 lg:top-auto lg:right-auto lg:-bottom-4 lg:left-[calc(50%-21px)] lg:w-[23%] lg:max-w-[15%] xl:max-w-[204px]',
    subtitle:
      'text-brand-bioderma block pr-2 text-[56px] leading-[1] font-bold uppercase lg:inline-block lg:text-4xl lg:text-[36px]',
    title:
      'mb-[2px] text-[20px] leading-[1] font-bold text-[#00C389] uppercase lg:mb-2 lg:text-4xl lg:text-[36px]',
    description:
      'text-brand-bioderma hidden text-lg leading-[1.2] font-medium uppercase lg:block lg:text-xl',
    logoRecommend:
      'absolute top-[13px] right-3 max-w-[140px] md:top-[100px] lg:hidden',
    circle: 'absolute top-[87px] left-[31.8%] z-2 mx-auto max-lg:hidden',
    videoWrapper:
      'absolute top-[167px] right-10 max-w-[562px] max-lg:hidden lg:w-[42%]',
    video: '',
    videoContent:
      'absolute top-0 right-0 bottom-0 left-0 z-1 flex flex-col items-center justify-center pt-4 pl-6 text-center',
    videoContentText:
      'mb-4 text-2xl leading-[1.2] font-medium text-white uppercase',
    videoLogo: 'absolute right-0 bottom-8 left-5 mx-auto',
    br: 'block max-lg:hidden'
  }
});
